import { useState, useCallback } from 'react';
import { PageContent } from '@/shared/components/PageContent';
import { UserModal } from '@/features/team/components/UserModals';
import type { AddUserFormValues } from '@/features/team/types/team.types';
import { TeamTable } from '@/features/team/components/TeamTable/TeamTable';
import { useTeam } from '@/features/team/hooks/useTeam/useTeam';
import { Button } from '@chikara/ui';
import styles from './TeamPage.module.css';
import { t } from '@/i18n';

export function TeamPage() {
  const { 
    members, 
    pagination,
    isLoading, 
    createMember,
    approveMember, 
    updateMember, 
    cancelMember, 
    getMember
  } = useTeam();

  const [addUserModalOpen, setAddUserModalOpen] = useState(false);

  const handleAddUser = useCallback(() => {
    setAddUserModalOpen(true);
  }, []);

  const handleAddUserSubmit = useCallback(async (values: AddUserFormValues) => {
    await createMember(values);
    setAddUserModalOpen(false);
  }, [createMember]);

  return (
    <PageContent 
      title={t('team.title')}
      button={
        <Button variant="primary" size="md" onClick={handleAddUser}>
          {t('team.modals.addUser.submit')}
        </Button>
      }
    > 
      <section className={styles.section}>
        <TeamTable
          members={members}
          isLoading={isLoading}
          pagination={pagination}
          onApprove={approveMember}
          onUpdate={updateMember}
          onDeactivate={cancelMember}
          onGetMember={getMember}
        />

        <UserModal
          mode="add"
          isOpen={addUserModalOpen}
          onClose={() => setAddUserModalOpen(false)}
          onSubmit={handleAddUserSubmit}
        />
      </section>
    </PageContent>
  );
}

export default TeamPage;
